import { Component } from '@angular/core';
import { IonicPage, ViewController, NavParams } from 'ionic-angular';
import { InfiniteScrollComponent } from '../../components/inifiniteScrollComponent';
import { LoadingComponent } from '../../components/loadingComponent';

@IonicPage({
  'name': 'CustomSelectorPage'
})
@Component({
  selector: 'page-custom-selector',
  templateUrl: 'custom-selector.html',
})
export class CustomSelectorPage extends InfiniteScrollComponent {

  public strSearchBar: string;

  constructor(
    public viewCtrl: ViewController,
    public params: NavParams,
    public loading: LoadingComponent
  ) {

    //servicio api a consultar los datos
    super(params.get('serviceAPI'));

    //carga el texto por defecto en la barra de busqueda
    this.strSearchBar = params.get('strSearchBar');

    //sobreescribir el campo fieldsSelect
    if (params.get('filterSelect')) {
      this.filterFields = params.get('filterSelect');
    }

    if(params.get('filterInclude')){
      this.filterInclude = params.get('filterInclude');
    }

    if(params.get('filterWhere')){
      this.filterWhere = params.get('filterWhere');
    }else{
      this.filterWhere = {};
    }

    if(params.get('isOpenErpApp')){
      this.isOpenErpApp = params.get('isOpenErpApp');
    }else{
      this.isOpenErpApp = false;
    }

    //si se le pasa un listado de items, se rellena el scroll con estos elementos
    //y tambien se permitirá usar el filtro de buscador
    if(params.get('listItems')){
      this.listItemsLocalSearch = this.listItems = params.get('listItems');
      this.isLocalData = true;
    }else{
      this.isLocalData = false;
    }

  }

  ionViewDidLoad() {

    //pide datos a la nube
    if(!this.isLocalData){
      super.ionViewDidLoad();
    }
    
  }

  /**
   * Function abstracta que devuelve el LoadingComponent
   */
  public getLoadingComponent():LoadingComponent{
      return this.loading;
  }
  
  /**
   * Selecciona un item en el listado y cierra ventana
   * @param item item seleccionado
   */
  public selectItem(item) {

    //cierra modal y envia item seleccionado
    this.viewCtrl.dismiss(item);

  }

  /**
   * Cerrar ventana
   */
  public dismiss() {
    this.viewCtrl.dismiss();
  }


}



// WEBPACK FOOTER //
// ./src/pages/custom-selector/custom-selector.ts